import { render, staticRenderFns } from "./zqfylqForm.vue?vue&type=template&id=512bc715&scoped=true"
import script from "./zqfylqForm.vue?vue&type=script&lang=js"
export * from "./zqfylqForm.vue?vue&type=script&lang=js"
import style0 from "./zqfylqForm.vue?vue&type=style&index=0&id=512bc715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512bc715",
  null
  
)

export default component.exports